import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";

import * as ROUTES from "../../../constant/routes";

const PrivacyNav = (props) => {
	const [show, setShow] = useState(false);

	return (
		<>
			<div className="tutorial-sidebar isOff1199">
				<div className="line" />
				<NavLink to={ROUTES.PRIVACY} activeClassName="active" className="tutorial-sidebar--item">
					Chính sách &amp; Quy định
				</NavLink>
				<div className="line" />
				<NavLink to={ROUTES.TERMS} activeClassName="active" className="tutorial-sidebar--item">
					Nguyên tắc chung
				</NavLink>
				<div className="line" />
				<NavLink to={ROUTES.PERSONAL_INFO} activeClassName="active" className="tutorial-sidebar--item">
					Chính sách bảo mật
				</NavLink>
				<div className="line" />
				<NavLink to={ROUTES.RESOLVE_CONFLIC} activeClassName="active" className="tutorial-sidebar--item">
					Giải quyết khiếu nại
				</NavLink>
				<div className="line" />
			</div>
			<div className="tutorial-dropdown isShow1199">
				<div className="custom-dropdown" onClick={() => setShow(!show)}>
					<div className={`dropdown-selected ${show ? "selected" : ""}`}>{props.active}</div>
					{show && (
						<div className="dropdown-option">
							<Link to={props.isMobile ? ROUTES.M_PRIVACY : ROUTES.PRIVACY} className="dropdown-option__item">
								<p className="text">Chính sách &amp; Quy định</p>
							</Link>
							<Link to={props.isMobile ? ROUTES.M_TERMS : ROUTES.TERMS} className="dropdown-option__item">
								<p className="text">Nguyên tắc chung </p>
							</Link>
							<Link
								to={props.isMobile ? ROUTES.M_PERSONAL_INFO : ROUTES.PERSONAL_INFO}
								className="dropdown-option__item">
								<p className="text">Chính sách bảo mật</p>
							</Link>
							<Link
								to={props.isMobile ? ROUTES.M_RESOLVE_CONFLIC : ROUTES.RESOLVE_CONFLIC}
								className="dropdown-option__item">
								<p className="text">Giải quyết khiếu nại</p>
							</Link>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default PrivacyNav;
